<template>
  <div class="examine-info">
    <header>
      <l-header headerTitle="审批详情" bg-color="rgba(51, 120, 255, 1)"></l-header>
      <div class="create-info">
        <span>由{{ getExamineCreateUser }}提交</span>
        <span>{{ getExamineCreateTime }}</span>
      </div>
    </header>
    <main>
      <div class="order-info">
        <l-card :form-list="cardFormList" :data="reimInfo"></l-card>
      </div>
<!--      发票详情-->
      <div class="invoice-info">
        <span>发票（{{ getInvoiceNum }}）</span>
        <template v-if="reimInfo.invoiceInfos && reimInfo.invoiceInfos.length">
          <div class="invoice-img" ref="invoice-img">
            <img
              v-for="(img, index) in reimInfo.invoiceInfos"
              :ref="`img${index}`"
              @click="handleImgClick($event, index, img)"
              :class="checkIndex === index ? 'check-img' : ''"
              :src="img.imagePath || getDefaultImg"
              title="发票"
              :key="img.id + index"
            >
          </div>
          <div class="schedule">
            <div
              :class="checkIndex === index ? 'check-icon' : ''"
              :key="img.id + index"
              v-for="(img, index) in reimInfo.invoiceInfos"></div>
          </div>
          <div class="info">
            <l-card :form-list="cardInvoiceInfo" :data="checkInvoice" half />
          </div>
        </template>
        <van-empty v-else description="暂无发票数据" />
      </div>
<!--      附件-->
      <div class="annex">
        <span>附件（{{ fileList.length }}）</span>
        <div class="uoloader">
          <van-uploader v-if="fileList && fileList.length" v-model="fileList" disabled :deletable='false'/>
          <van-empty v-else description="暂无附件数据" />
        </div>
      </div>
      <div class="examine">
        <span>审批流程</span>
        <div v-if="examineInfo && examineInfo.nodeList" class="tab-content">
          <van-steps direction="vertical" active="100000" active-color="rgba(0,0,0,.85)">
            <van-step v-for="(item, index) in examineInfo.nodeList" :key="item.id">
              <template slot="inactive-icon">
                <div class="left-head">
                  {{ joinHandlerName(item.nodeHandlerList || [], item.approvalType).split('')[0] }}
                  <div class="icon allIconFont" :style="{ color: getExamineIconColor(item.status, index) }">
                    {{ getExamineIcon(item.status, index) }}
                  </div>
                </div>
              </template>
              <header class="step-head">
                <h3>{{ index === 0 ? '发起审批' : '审批' }}</h3>
                <p>{{ item.status === 'RUNNING' ? '' : item.updateTime || '' }}</p>
              </header>
              <main class="step-main">
                <div v-if="index === 0">
                  <span>{{ joinHandlerName(item.nodeHandlerList || [], item.approvalType, index, item) + '提交单据' }}</span>
                </div>
                <!--           节点正在审核, 正在审核前面需要增加"待"-->
                <div v-else-if="item.status === 'RUNNING'">
                  <span>{{'待 ' + joinHandlerName(item.nodeHandlerList || [], item.approvalType, index, item) }}</span>
                </div>
                <div v-else>
                  <div class="single-item">
                    <span>{{ joinHandlerName(item.nodeHandlerList || [], item.approvalType) }}</span>
                    <span>
                    <StatusTag
                      :customStyle="{ margin: '0 0 0 6px' }"
                      :haveRgbaBgColor="true"
                      :type="getHandlerResultClassMap(item.nodeHandlerList[0].result)"
                    >
                      {{ getMainResultTextMap[item.nodeHandlerList[0].result] }}
                    </StatusTag>
                  </span>
                  </div>
                  <div class="msg" v-if="item.nodeHandlerList.length === 1 && item.nodeHandlerList[0].comment">
                    {{ item.nodeHandlerList[0].comment || '' }}
                  </div>
                </div>
              </main>
            </van-step>
          </van-steps>
        </div>
        <van-empty v-else description="暂无审批流程数据" />
      </div>
    </main>
    <footer class="allIconFont" v-if="examineInfo.operation">
      <span @click="handleBtnClick('REJECT')"><span class="error">{{ '\ue636' }}</span>驳回</span>
      <span @click="handleBtnClick('AGREE')"><span class="success">{{ '\ue640' }}</span>通过</span>
    </footer>
<!--    examineId不存在表示从报销详情跳转过来需要修改 已驳回 已撤回-->
    <footer v-if="!examineId && [3, 4].includes(reimInfo.reimStatus)" class="allIconFont">
      <span @click="handleDel"><span class="error">{{ '\ue636' }}</span>删除</span>
      <span @click="handleEdit"><span class="info">{{ '\ue6b0' }}</span>修改报销</span>
    </footer>
    <my-popup ref="popupRef" :current-pop-type="currentPopType" :call-back="popupConfirmCallBack" />
  </div>
</template>
<script>
import Header from '@/components/Header/index.vue'
import pdfImg from '@/assets/img/invoice-pdf.png'
import StatusTag from '@/components/StatusTag/index.vue'
import { mapState, mapActions } from 'vuex'
import { Empty, Uploader, Step, Steps, Toast } from 'vant'
import Card from './card.vue'
import {
  formExamineInfo,
  invoiceInfo,
  handlerResultMap,
  examineTypeMap,
  mainResultTextMap,
  handlerResultClassMap,
  examineIconMap
} from './config'
import MyPopup from './popup.vue'
export default {
  components: {
    'my-popup': MyPopup,
    StatusTag,
    [Uploader.name]: Uploader,
    [Empty.name]: Empty,
    [Steps.name]: Steps,
    [Step.name]: Step,
    'l-card': Card,
    'l-header': Header
  },
  props: {
    examineId: {
      type: String,
      default: ''
    },
    reimNo: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState('my-examine', ['reimInfo', 'examineInfo']),
    getInvoiceNum () {
      let text = '0'
      if (this.reimInfo.invoiceInfos && this.reimInfo.invoiceInfos.length) {
        text = `${(this.checkIndex + 1)}/${this.reimInfo.invoiceInfos.length}`
      }
      return text
    },
    getMainResultTextMap () {
      return mainResultTextMap
    },
    getDefaultImg () {
      return pdfImg
    },
    getExamineCreateUser () {
      return this.reimInfo.createUserName || '--'
    },
    getExamineCreateTime () {
      return this.reimInfo.submitTime || '--'
    },
    cardFormList () {
      return formExamineInfo
    },
    cardInvoiceInfo () {
      return invoiceInfo
    }
  },
  data () {
    return {
      invoiceImgShow: false,
      currentPopType: '',
      time: null,
      fileList: [],
      checkIndex: 0,
      checkInvoice: {}
    }
  },
  methods: {
    ...mapActions('my-examine', ['getExamineInfo', 'examine', 'delReimById']),
    getExamineIcon (status, index) {
      return examineIconMap.get(index === 0 ? '0' : status).icon
    },
    getExamineIconColor (status, index) {
      return examineIconMap.get(index === 0 ? '0' : status).color
    },
    /**
     * @description 修改报销单据
     */
    handleEdit () {
      sessionStorage.clear()
      this.$router.push({ path: '/reimbursement/launch-reim', query: { id: this.reimNo } })
    },
    /**
     * @description 修改报销单据
     */
    async handleDel () {
      const flag = await this.delReimById(this.reimInfo.reimNo)
      if (!flag) this.$router.go(-1)
    },
    /**
     * @description 操作审批流
     * @param list
     * @return {Promise<void>}
     */
    async setExamine (list) {
      await this.examine(list)
      await this.getInfo()
    },
    /**
     * @description 点击驳回/通过按钮
     * @param type
     */
    handleBtnClick (type) {
      this.currentPopType = type
      this.$refs.popupRef.show = !this.$refs.popupRef.show
      this.$refs.popupRef.message = ''
    },
    /**
     * @description 弹窗确认后的callback
     */
    popupConfirmCallBack (message) {
      this.setExamine([{
        comment: message,
        id: this.examineId,
        result: this.currentPopType
      }])
    },
    getHandlerResultClassMap (result) {
      return handlerResultClassMap[result]
    },
    /**
     * @description 根据approvalType获取文字
     * @param list
     * @param approvalType
     * @return {string} 返回join好的名称
     */
    joinHandlerName (list, approvalType, index, item) {
      const text = []
      // 状态文字
      const getStatusText = (i) => {
        if (item && item.status === 'RUNNING') return (handlerResultMap[i.result] && index !== 0) ? `(${handlerResultMap[i.result]})` : ''
        return ''
      }
      list.forEach(i => {
        text.push(`${(i.handlerName || '')}${getStatusText(i)}`)
      })

      // 拼接审批方式文案
      if (examineTypeMap[(approvalType + '')] && list.length !== 1) {
        return text.join('、') + (examineTypeMap[(approvalType + '')] ? ` ${examineTypeMap[(approvalType + '')]}` : '')
      }

      return text.join('、')
    },
    /**
     * @description 点击发票图片触发click函数
     * @param e
     * @param index
     */
    handleImgClick (e, index, img) {
      this.checkIndex = index
      this.checkInvoice = img
      clearInterval(this.time)
      this.time = null
      // 自己宽度 + 距离视口大小
      const sonWidth = this.$refs[`img${index}`][0].offsetWidth
      const maxLeft = this.$refs[`img${index}`][0].x + sonWidth
      const parentWidth = this.$refs['invoice-img'].offsetWidth
      const scrollMaxLength = this.$refs['invoice-img'].scrollWidth - this.$refs['invoice-img'].clientWidth
      if (maxLeft >= parentWidth) {
        // 目的地终点
        let end = null
        if (index === 7) {
          end = scrollMaxLength
        } else {
          end = this.$refs['invoice-img'].scrollLeft + sonWidth + 24
        }
        // 重置一下end，如果超过最大长度就按照最大长度核定
        end = end > scrollMaxLength ? scrollMaxLength : end
        // 开启定时器每次加一点
        this.time = setInterval(() => {
          // 直到到达终点 || 大于终点 || 实体不存在
          if (!this.$refs['invoice-img'] || this.$refs['invoice-img'].scrollLeft >= end) {
            clearInterval(this.time)
            this.time = null
            return
          }
          this.$refs['invoice-img'].scrollLeft += sonWidth * 0.2
        }, 10)
      }
    },
    /**
     * @description 查询详情信息
     */
    async getInfo () {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      try {
        await this.getExamineInfo({ reimNo: this.reimNo, id: this.examineId })
        if (this.reimInfo.invoiceInfos && this.reimInfo.invoiceInfos.length) {
          this.checkInvoice = this.reimInfo.invoiceInfos[0]
        }
        this.fileList = []
        this.reimInfo.attachmentInfos.map(item => {
          let obj = {}
          obj.url = item.fileDirectory
          this.fileList.push(obj)
        })
      } catch (e) {
      } finally {
        Toast.clear({
          clearAll: true
        })
      }
    }
  },
  async mounted () {
    await this.getInfo()
  },
  beforeDestroy () {
    // 销毁时清除定时器
    clearInterval(this.time)
    this.time = null
  }
}
</script>
<style lang="less" scoped src="./index.less" />
